<app-header></app-header>
<app-navbar [selected]="'coins'"></app-navbar>
<div class="d-flex">
    <aside role="complementary" [attr.aria-label]="'asideDescription' | translate">
        <app-sidebar [items]="links"></app-sidebar>
    </aside>
    <main class="ps-5 w-100 ">
        <div class="row">
            <div class="col-md-6 fw-bold">
                <h2 class="mb-3 textformat">{{ 'sidebar.coins' | translate }}</h2>
            </div>
            <div class="col-md-6 text-end">
            </div>
        </div>
        @if (this.coinReponse.coinDto && this.coinReponse.coinDto.length > 0) {
        <div>
            <fieldset role="radiogroup">
                <table class="table text-center mt-2" role="grid" [attr.aria-label]="'sidebar.coins' | translate">
                    <thead>
                        <tr role="row">
                            <th scope="col"><span class="visually-hidden">{{ 'seleccionarFila' | translate }}</span>
                            </th>
                            <th scope="col">{{ 'patternVat.codi' | translate }}</th>
                            <th scope="col">{{ 'tariffRole.descripcion' | translate }}</th>
                            <th scope="col">{{ 'discount.decimalValue' | translate }}</th>
                            <th scope="col">{{ 'typesVat.date' | translate }}</th>
                            <th scope="col">{{ 'typesVat.endDate' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let coin of coinReponse.coinDto; let i = index"
                            [ngClass]="{'resaltado': selectedRowId == coin.currencyCode}" role="row">
                            <td role="gridcell">
                                <input [attr.aria-label]="'flexRadioDefault' + i" type="radio" name="flexRadioDefault"
                                    [id]="'flexRadioDefault' + i" [checked]="selectedRowId === coin.currencyCode"
                                    (click)="checkRow(coin)">
                                <label [for]="'flexRadioDefault' + i" class="visually-hidden">
                                    {{ 'seleccionarFilaCon' | translate }}:
                                    {{ 'patternVat.codi' | translate }} {{ coin.currencyCode }},
                                    {{ 'tariffRole.descripcion' | translate }} {{
                                    coin.currencyTraductionDto?.[0]?.description || 'N/A' }},
                                    {{ 'discount.decimalValue' | translate }} {{ coin.decimalAdjustment }},
                                    {{ 'typesVat.date' | translate }} {{
                                    coin.periodBaseCurrencyDto?.[0]?.periodBaseCurrencyPkDto?.startDate || 'N/A' }},
                                    {{ 'typesVat.endDate' | translate }} {{ coin.periodBaseCurrencyDto?.[0]?.endDate ||
                                    'N/A' }}
                                </label>
                            </td>
                            <td role="gridcell"><span>{{ coin.currencyCode }}</span></td>
                            <td role="gridcell"><span *ngIf="coin.currencyTraductionDto">{{
                                    coin.currencyTraductionDto[0].description }}</span></td>
                            <td role="gridcell"><span>{{ coin.decimalAdjustment }}</span></td>
                            <td role="gridcell"><span *ngIf="coin.periodBaseCurrencyDto">{{
                                    coin.periodBaseCurrencyDto[0].periodBaseCurrencyPkDto?.startDate | date:'dd/MM/yyyy' }}</span></td>
                            <td role="gridcell"><span *ngIf="coin.periodBaseCurrencyDto">{{
                                    coin.periodBaseCurrencyDto[0].endDate | date:'dd/MM/yyyy' }}</span></td>
                        </tr>
                    </tbody>
                </table>
            </fieldset>
        </div>
        }
        <!--       <form [formGroup]="serviceForm" (ngSubmit)="createOrUpdateService()">
            <label class="form-label" for="codeService">{{ 'tariffServices.codeService' | translate }}<span>
                    *</span></label>
            <input type="text" class="form-control color-text" name="codeService" id="codeService" required
                formControlName="codeService"
                [class.input-error]="sharedService.controlInput(serviceForm,'codeService')">
            <app-message-input [form]="serviceForm" [field]="'codeService'"></app-message-input>

            <button type="submit" class="btn custombutton mt-3 mx-2">{{ 'buttons.save' | translate
                }}</button>
        </form>-->
 

    </main>

</div>